var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#797F89",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9 5.25V9h3.75M9 15.75a6.75 6.75 0 1 1 0-13.5 6.75 6.75 0 0 1 0 13.5Z"
})));
export { SvgClock as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgNS4yNVY5SDEyLjc1TTkgMTUuNzVDNS4yNzIwOCAxNS43NSAyLjI1IDEyLjcyNzkgMi4yNSA5QzIuMjUgNS4yNzIwOCA1LjI3MjA4IDIuMjUgOSAyLjI1QzEyLjcyNzkgMi4yNSAxNS43NSA1LjI3MjA4IDE1Ljc1IDlDMTUuNzUgMTIuNzI3OSAxMi43Mjc5IDE1Ljc1IDkgMTUuNzVaIiBzdHJva2U9IiM3OTdGODkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";